import Vue from 'vue';
import http from 'axios';
import { Video } from '@app/global/video';
export default Vue.extend({
    props: {
        uri: String,
        autoplay: {
            type: Boolean,
            default: false,
        },
        quality: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            video: null,
            playing: false,
        };
    },
    created: function () {
        if (this.uri) {
            this.getVideoData();
        }
    },
    methods: {
        getVideoData: function () {
            if (this.$helpers.storage.get(this.videoStorageKey)) {
                this.fetchFromLocalStorage();
            }
            else {
                this.fetchFromBackend();
            }
        },
        fetchFromLocalStorage: function () {
            var _this = this;
            this.video = this.$helpers.storage.get(this.videoStorageKey);
            this.$nextTick(function () {
                new Video([_this.$refs.video]);
            });
        },
        fetchFromBackend: function () {
            var _this = this;
            http.get('/api/video/' + this.uri.replace('/videos/', '')).then(function (res) {
                _this.video = res.data;
                _this.$helpers.storage.set(_this.videoStorageKey, res.data);
                _this.$nextTick(function () {
                    new Video([_this.$refs.video]);
                });
            });
        }
    },
    computed: {
        videoStorageKey: function () {
            return "video-data-" + this.uri.replace('/videos/', '');
        }
    },
    activated: function () {
        if (this.video && this.autoplay) {
            var video = this.$refs.video;
            video.muted = true;
            var playPromise = video.play();
            if (typeof playPromise !== 'undefined') {
                playPromise.catch(function (err) {
                    // ignore errors
                });
            }
        }
    },
    deactivated: function () {
        if (this.video) {
            this.$refs.video.pause();
        }
    }
});
